import Header from "@/components/Header/components";
import FormsMixin from "@/mixins/FormsMixin";
import { PEDIDO } from "@/store/modules/PedidoCompletados/types";
import { CLIENTES } from "@/store/modules/SeleccionCliente/types";
import { ARTICULO, CESTA } from "@/store/modules/ventas/types";
import { Component } from "vue-property-decorator";
import { Action } from "vuex-class";

import Template from "./template.vue";

@Component({
  mixins: [Template],
  components: { Header }
})
export default class PedidoCompletados extends FormsMixin {
  @Action("listarPedidos", { namespace: "PedidoCompletados" }) listarPedidos!: Function;
  @Action("listarLineas", { namespace: "PedidoCompletados" }) listarLineas!: Function;

  public listadoPedidos: Array<PEDIDO> = [];
  public listadoLineas: Array<ARTICULO> = [];
  public cesta: Array<CESTA> = [];
  public cliente: CLIENTES = {
    CODCLI: "",
    NOMCLI: "",
    AT_APP: "",
    AT_PASSWORD: "",
    CODREP: "",
    E_MAIL: "",
    NIFCLI: ""
  };



  async mounted() {
    this.$root.$emit("loading", true);
    const esCliente = JSON.parse(localStorage.getItem('userLogged') || '{}').esCliente;
    this.cliente = JSON.parse(localStorage.getItem('CliePedido') || '{}');

    if (esCliente) {
      this.listadoPedidos = await this.listarPedidos({ codcli: this.cliente.CODCLI });
    } else {
      const idRep = JSON.parse(localStorage.getItem('userLogged') || '{}').id;
      this.listadoPedidos = await this.listarPedidos({ codcli: this.cliente.CODCLI, codrep: idRep });
    }



    this.$root.$emit("loading", false);
    this.$root.$on("devolverCesta", (cesta: Array<CESTA>) => { this.cesta = cesta });
    this.$root.$emit("solicitarCesta");

    window.scrollTo(0, 0);
  }

  getClaseSituacion(item: any) {    
    let clase = "btn-error";
    switch (item.SITUACION) {
      case "Pendiente":
        clase = "btn-pendiente";
        break;
      case "Activo":
        clase = "btn-activo";
        break;
      case "Servido":
        clase = "btn-servido";
        break;
    }

    return clase;
  }

  getCantidadCesta(codart: string) {
    const existe = this.cesta.find(x => x.articulo.CODART == codart);
    if (existe != undefined) {
      return existe.cantidad
    } else { return 0; }
  }

  AñadirACesta(item: ARTICULO) {    
    
    this.$root.$emit("addToCart", item)
  }

  AñadirPedido(item: PEDIDO){
    item.LINEAS.forEach(art =>{
      this.AñadirACesta(art);
    })
  }

  RestarDeCesta(item: ARTICULO) {
    this.$root.$emit("RestCart", item)
  }
  
  async MuestraLineas(idpedv: number){
    this.listadoLineas = await this.listarLineas({ idpedv: idpedv })
  }



  HayLineas(){
    return (this.listadoLineas.length>0)
  }
}